export const textInputRegexp = new RegExp(/^[A-Za-zÀ-úÀ-ÿÀ-ÿÀ-ÖØ-öø-ÿŁłěßšŠ0-9 \t^,.;:!?&%'`"@|+*=/\\\-_~#()€$℃{}<>\[\]\n]+$/);

export const passwordRegexp = new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{10,}$/)

export const fileNameRegexp = new RegExp(/^[A-Za-zäöåÄÖÅ0-9 \t^,.:!?&%@/\\\-_()€$\[\]\n]+$/);
